module.exports = __webpack_public_path__ + "img/main_section_img5.4774bf7a.svg";